import React, { Suspense } from 'react';
import ReactDOM from "react-dom/client";

// MUI
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// Third party
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { PersistGate } from 'redux-persist/integration/react';

// Hooks
import { useDelayedRender } from './hooks';

// Components
import './global.css';
import App from "./App";
import { store, persistor } from './store';
import { LoadingScreen } from './components/SuspenseLoadingScreen';
import { CustomSnackbarProvider } from './layouts/providers/CustomSnackbarProvider';

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

function DelayedSuspense({ children, fallback }: { children: React.ReactNode; fallback: React.ReactNode }) {
  const show = useDelayedRender(200);
  return (
    <Suspense fallback={show ? fallback : null}>
      {children}
    </Suspense>
  );
}

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}>
          <DelayedSuspense fallback={<LoadingScreen />}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <CustomSnackbarProvider>
                <PersistGate loading={<LoadingScreen />} persistor={persistor}>
                  <App />
                </PersistGate>
              </CustomSnackbarProvider>
            </LocalizationProvider>
          </DelayedSuspense>
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);